declare var gtag: (...args: any[]) => void;
declare var fbq: (...args: any[]) => void;

export function trackEvent(eventName: string, args?: any): void {
  if (gtag) {
    gtag('event', eventName, args);
  } else {
    console.warn('gtag() not defined');
  }

  /**
   * @see https://developers.facebook.com/docs/facebook-pixel/implementation/conversion-tracking#tracking-custom-events
   */
  if (fbq) {
    fbq('trackCustom', eventName, args);
  } else {
    console.warn('fbq() not defined');
  }
}

export function trackScreenView(screenName: string): void {
  if (gtag) {
    gtag('event', 'screen_view', { screen_name: screenName });
  } else {
    console.warn('gtag() not defined');
  }
}
